module.exports = __webpack_public_path__ + "static/media/img99_R.a35e09f8.jpg";